import React, { useState, useEffect } from 'react';

import { Button } from 'reactstrap';

import TrasformaDateAUmano from '../TrasformaDateAUmano.js';
import Parametri from '../../parametri';
import Clessidra from '../Clessidra.js';

import { Page, Text, View, Document, Image, PDFViewer, pdf } from '@react-pdf/renderer';
import styles from '../stiliPdf.js';

function VisualizzaVerbale(props) {

  const STATO_INDEFINITO = 0;
  const STATO_RICERCA_DATI = 1;
  const STATO_VISUALIZZA_PDF = 2;
  const STATO_DOWNLOAD_PDF = 3;

  const [statoPagina, setStatoPagina] = useState(STATO_INDEFINITO);
  const [fileLogo, setFileLogo] = useState('');
  const [typeLogo, setTypeLogo] = useState('');
  const [nomeSocieta, setNomeSocieta] = useState('');
  const [capSocieta, setCapSocieta] = useState('');
  const [cittaSocieta, setCittaSocieta] = useState('');
  const [indirizzoSocieta, setIndirizzoSocieta] = useState('');
  const [pIvaSocieta, setPIvaSocieta] = useState('');
  const [codiceFiscaleSocieta, setCodiceFiscaleSocieta] = useState('');

  useEffect(() => {
    if (statoPagina == STATO_DOWNLOAD_PDF) {
      downloadModuloPDF();
    }
  }, [statoPagina]);

  function scaricaLogo() {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ op: "ricercaLogo", emak: props.emak, sessionId: props.sessionId })
    };

    fetch(Parametri("serverURL", props.identitaSelezionata), requestOptions)
      .then(risposta => risposta.json())
      .then(
        (valoreDiRitorno) => {
          if (valoreDiRitorno.risultatoOperazione === 1) {
            if (valoreDiRitorno.risultatoRitorno[0].FILE !== undefined) {
              setFileLogo(valoreDiRitorno.risultatoRitorno[0].FILE);
              setTypeLogo(valoreDiRitorno.risultatoRitorno[0].TYPE);
              setNomeSocieta(valoreDiRitorno.risultatoRitorno[0].NOME);
              setCapSocieta(valoreDiRitorno.risultatoRitorno[0].CAP);
              setCittaSocieta(valoreDiRitorno.risultatoRitorno[0].CITTA);
              setIndirizzoSocieta(valoreDiRitorno.risultatoRitorno[0].INDIRIZZO);
              setPIvaSocieta(valoreDiRitorno.risultatoRitorno[0].PIVA);
              setCodiceFiscaleSocieta(valoreDiRitorno.risultatoRitorno[0].CODICE_FISCALE);
            }

            if (props.azione == 'visualizza') {
              setStatoPagina(STATO_VISUALIZZA_PDF);
            } else {
              setStatoPagina(STATO_DOWNLOAD_PDF);
            }
          }
        },
        (error) => { console.log("Errore connessione"); }
      );
  }

  useEffect(() => {
    setStatoPagina(STATO_RICERCA_DATI);
    scaricaLogo();
  }, []);

  const DocumentoPDF = (props) => {

    const presentiDettaglio = props.elencoPresenti
      .map(idNum => props.elencoConvocati.find(c => parseInt(c.ID, 10) === idNum))
      .filter(Boolean);

    let odgArr = props.odg;

    if (typeof odgArr === "string") {
      try { odgArr = JSON.parse(odgArr); } catch(e) { odgArr = []; }
    }

    if (!Array.isArray(odgArr)) odgArr = [];

    const odgRighe = odgArr
      .map(x => (typeof x === "string" ? x : (x?.testo ?? x?.TESTO ?? "")))
      .map(s => (s !== null && s !== undefined) ? String(s).trim() : "")
      .filter(Boolean);      
    
    return (
      <Document>
        <Page size="A4" orientation="portrait" style={styles.page}>
          <View style={{ width: "100%" }}>

            <View style={styles.tableIntestazione}>{/*apre table intestazione*/}
              <View wrap={false} style={styles.tableRowIntestazione}>
                <View style={styles.tableColIntestazioneSx}>
                  <View style={styles.tableCell}>
                    {fileLogo !== "" ? (
                      <Image style={styles.logo} src={"data:" + typeLogo + ";base64," + fileLogo} />
                    ) : (
                      <Text></Text>
                    )}
                  </View>
                </View>

                <View style={styles.tableColIntestazioneDx}>
                  <View style={styles.tableCellIntestazione}>
                    {nomeSocieta !== "" ? <Text style={styles.nomesocieta}>{nomeSocieta}</Text> : <Text></Text>}

                    {indirizzoSocieta !== "" ? (
                      <Text style={styles.datisocieta}>
                        {indirizzoSocieta}
                        {cittaSocieta !== "" ?
                          (capSocieta !== "" ? " " + capSocieta + " " + cittaSocieta : " " + cittaSocieta)
                          : ""}
                      </Text>
                    ) : (
                      <Text></Text>
                    )}

                    {pIvaSocieta !== "" ? <Text style={styles.datisocieta}>Partita IVA: {pIvaSocieta}</Text> : <Text></Text>}
                    {codiceFiscaleSocieta !== "" ? <Text style={styles.datisocieta}>Codice Fiscale: {codiceFiscaleSocieta}</Text> : <Text></Text>}

                    <Text style={styles.titolo}>
                      {props.titolo}
                    </Text>
                  </View>
                </View>
              </View>
            </View>{/*chiude table intestazione*/}

            <View>
              <Text style={[styles.testoGrande, styles.tGrassetto, styles.tCentrato, styles.tSpazio10Bottom]}>
                VERBALE DI ASSEMBLEA {props.tipoAssemblea.toUpperCase()}
              </Text>

              <Text style={[styles.t12, styles.tSpazio10Bottom]}>
                Il giorno <TrasformaDateAUmano data={props.dataAssemblea}/> alle ore {props.oraAssemblea} presso {props.luogoAssemblea},
              </Text>

              <Text style={[styles.t12]}>
                si è riunita{props.convocazione} l'assemblea {props.tipoAssemblea} {props.tipo=="direttivo" ? "del Consiglio Direttivo" : "dei soci"} della
              </Text>

              <Text style={[styles.t12, styles.tGrassetto, styles.tSpazio10Bottom]}>{nomeSocieta},</Text>

              <Text style={[styles.t12]}>
                per discutere e deliberare sul seguente <Text style={styles.tGrassetto}>ordine del giorno</Text>:
              </Text>

              {odgRighe.length === 0 ? (
                <Text style={styles.t12}>- (ordine del giorno non definito)</Text>
              ) : (
                odgRighe.map((t, i) => (
                  <Text key={i} style={styles.t12}>
                    {i + 1}) {t}
                  </Text>
                ))
              )}

              <Text style={[styles.t12, styles.tSpazio10Bottom]}></Text>

              <Text style={[styles.t12, styles.tGrassetto]}>

                {props.numPresenti!=1 ?
                  <>Sono presenti i seguenti {props.numPresenti} {props.tipo === "direttivo" ? "consiglieri" : "soci"} sul totale di {props.numConvocati} convocati:</>
                : 
                  <>E' presente il seguente {props.tipo === "direttivo" ? "consigliere" : "socio"} sul totale di {props.numConvocati} convocati:</>
                }
              </Text>                  
              <View style={[styles.t12, styles.tSpazio10Bottom]}>
                <Text style={[styles.t12]}>
                  {presentiDettaglio
                    .map(p => `- ${p.COGNOME} ${p.NOME}${p.NUMERO_TESSERA ? ` (${p.NUMERO_TESSERA})` : ""}`)
                    .join("\n")}
                </Text>
              </View>                

              <Text style={[styles.t12, styles.tSpazio10Bottom]}>
                Essendo presenti {props.numPresenti} {props.tipo === "direttivo" ? "consiglieri" : "soci"} su {props.numConvocati}, l'assemblea è{" "}
                {props.valida==1 ? "regolarmente costituita" : "non valida"}.
              </Text>

              <Text style={[styles.t12]}>
                {props.verbale}
              </Text>
            </View>

            <View style={styles.tableNoBordo} wrap={false}>
              <View wrap={false} style={styles.tableRow}>
                <View style={{width: 45*100/100+"%", borderBottom: "1px solid black"}}> 
                  <Text style={[styles.tableCellGrassettoAllineatoCentrato, {paddingBottom:30}]}>Il Segretario</Text> 
                </View>  
                <View style={{width: 10*100/100+"%"}}> 
                  <Text style={[styles.tableCellGrassettoAllineatoCentrato, {paddingBottom:30}]}></Text> 
                </View>  
                <View style={{width: 45*100/100+"%", borderBottom: "1px solid black"}}> 
                  <Text style={[styles.tableCellGrassettoAllineatoCentrato, {paddingBottom:30}]}>Il Presidente</Text> 
                </View>  
              </View>
            </View>

          </View>

          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) => (`${pageNumber} / ${totalPages}`)}
            fixed
          />
        </Page>
      </Document>
    );
  };

  async function downloadModuloPDF() {
    const blob = await pdf(<DocumentoPDF {...props} />).toBlob(); // Convert the document to a Blob
    const url = URL.createObjectURL(blob); // Create a temporary URL
    const link = document.createElement("a"); // Create a link element
    link.href = url; // Assign the Blob URL
    link.download = "Verbale.pdf"; // Set the download filename
    document.body.appendChild(link); // Append the link to the document
    link.click(); // Simulate a click to trigger the download
    document.body.removeChild(link); // Clean up
    URL.revokeObjectURL(url); // Release the memory
  }

  if (statoPagina == STATO_RICERCA_DATI) {
    const h = props.dimensioniApp ? props.dimensioniApp.yMain : "";
    return (<div style={{ height: h, width: "100%", display: "flex" }}><Clessidra loading={true} /></div>);
  }

  if (statoPagina == STATO_VISUALIZZA_PDF) {
    const h = props.dimensioniApp ? props.dimensioniApp.yMain : "";
    return (
      <div style={{ display: "flex", flexDirection: "column", height: h }}>
        <PDFViewer style={{ width: "100%", flex: 1 }}>
          <DocumentoPDF {...props} />
        </PDFViewer>
        <Button color="primary" style={{ margin: 2 }} onClick={() => props.callback()}>Chiudi</Button>
      </div>
    );
  }

  if (statoPagina == STATO_DOWNLOAD_PDF) {
    return (<></>);
  }

  return (
    <div>Errore VisualizzaVerbale: pagina non trovata</div>
  );
}

export default VisualizzaVerbale;
